export enum IconTagTypes {
  Attachments = 'Attachments',
  MedicationGroup = 'MedicationGroup',
  Description = 'Description',
  Link = 'Link',
  Note = 'Note',
  Infinite = 'Infinite',
  References = 'References',
}
